import { requestService } from 'shared/utils/services/requestService';

export const fetchCurrentUser = () => {
  return requestService({
    url: '/web-api/v1/users/me',
    method: 'get',
  });
};
